import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {PrimaryButton} from "../../../basic-components/buttons/primary-button";
import {CardBox} from "../../../basic-components/card/card.box";
import {DotsAnimationComponent} from "../../../components/dots-animation/dots-animation.component";
import {BookingSearchStrategiesDropDownComponent} from "./booking-search-strategies-drop-down.component";

const ContainerBox = styled(CardBox)`
    display: flex;
    flex-direction: column;
    min-width: 420px;
    overflow: hidden;
    box-shadow: none;
    padding: 0;
    ${props => props.theme.screenMediaQuery.smallScreen} {
        width: 100%;
        height: 100%;
        border: none;
        
    }
`


const SectionBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${props => props.theme.spacing.cardDefaultPadding};
`

const HeaderSectionBox = styled(SectionBox)`
    border-bottom: 1px solid ${props => props.theme.border.mainColor};
`

const ContentSectionBox = styled(SectionBox)`
    flex-grow: 1;
    overflow-y: auto;
`

const FooterSectionBox = styled(SectionBox)`
    display: flex;
    flex-direction: column;
`

const SearchButton = styled(PrimaryButton)`
    min-height: 52px;
`


export const BookingSearchFiltersComponent = observer(() => {
    const services = useServices();
    const currentStrategy = services.agencyBookingSearch.currentStrategy;
    const onSearchClick = async () => {
        if(currentStrategy.isSearchInProgress) {
            return;
        }
        await currentStrategy.applySearch();
        await services.sideMenu.agencyBookingSearchSideMenuController.close();
    }


    const renderSearchButtonContent = () => {
        if(currentStrategy.isSearchInProgress) {
            return (
                <DotsAnimationComponent/>
            );
        } else {
            return services.language.translate('Search')
        }
    }

    return (
        <ContainerBox>
            <HeaderSectionBox>


                <BookingSearchStrategiesDropDownComponent/>
            </HeaderSectionBox>

            <ContentSectionBox>
                {currentStrategy.renderSearchFields()}
            </ContentSectionBox>

            <FooterSectionBox>
                <SearchButton onClick={onSearchClick}>
                    {renderSearchButtonContent()}
                </SearchButton>
            </FooterSectionBox>

        </ContainerBox>
    )
})